<ix-icon name="info"></ix-icon>
<span class="message" [innerHTML]="connectionText | translate"></span>
